/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { UpdateDataFirstStage200ResponseData } from './UpdateDataFirstStage200ResponseData'
import {
  UpdateDataFirstStage200ResponseDataFromJSON,
  UpdateDataFirstStage200ResponseDataFromJSONTyped,
  UpdateDataFirstStage200ResponseDataToJSON,
} from './UpdateDataFirstStage200ResponseData'

/**
 *
 * @export
 * @interface UpdateDataFirstStage200Response
 */
export interface UpdateDataFirstStage200Response {
  /**
   *
   * @type {boolean}
   * @memberof UpdateDataFirstStage200Response
   */
  status: boolean
  /**
   *
   * @type {UpdateDataFirstStage200ResponseData}
   * @memberof UpdateDataFirstStage200Response
   */
  data: UpdateDataFirstStage200ResponseData
}

/**
 * Check if a given object implements the UpdateDataFirstStage200Response interface.
 */
export function instanceOfUpdateDataFirstStage200Response(
  value: object
): value is UpdateDataFirstStage200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function UpdateDataFirstStage200ResponseFromJSON(
  json: any
): UpdateDataFirstStage200Response {
  return UpdateDataFirstStage200ResponseFromJSONTyped(json, false)
}

export function UpdateDataFirstStage200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateDataFirstStage200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: UpdateDataFirstStage200ResponseDataFromJSON(json['data']),
  }
}

export function UpdateDataFirstStage200ResponseToJSON(
  value?: UpdateDataFirstStage200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: UpdateDataFirstStage200ResponseDataToJSON(value['data']),
  }
}
